module.exports = __webpack_public_path__ + "img/ck-mutil-star4-bg.43cb3237.png";